var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"el-dialog-custom",attrs:{"title":"战表管理","top":"3vh","width":"95%","visible":_vm.visible,"close-on-click-modal":false,"append-to-body":true},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"loading"},[_vm._v("正在加载...")]),_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }